import { useNavigate, useLocation, useOutlet } from 'react-router-dom';
import { Layout as AntLayout, Menu, Spin } from 'antd';
import React, { Suspense, useState, useEffect } from 'react';
import ErrorBoundary from './ErrorBoundary';
import {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  BookOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  LogoutOutlined,
  AppstoreOutlined,
  SettingOutlined,
  TagsOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content } = AntLayout;

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const outlet = useOutlet();

  const menuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: '概览' },
    { key: '/classes', icon: <AppstoreOutlined />, label: '班级管理' },
    { key: '/course-categories', icon: <TagsOutlined />, label: '课程类别' },
    { key: '/teachers', icon: <TeamOutlined />, label: '老师管理' },
    { key: '/students', icon: <UserOutlined />, label: '学生管理' },
    { key: '/enrollments', icon: <BookOutlined />, label: '课程管理' },
    { key: '/attendance', icon: <CheckCircleOutlined />, label: '考勤记录' },
    { key: '/approvals', icon: <SolutionOutlined />, label: '审批管理' },
    {
      key: '/stats',
      icon: <BarChartOutlined />,
      label: '统计报表',
      children: [
        { key: '/stats/fees', label: '费用统计' },
        { key: '/stats/teacher-income', label: '老师收入' },
        { key: '/stats/attendance', label: '考勤统计' },
      ],
    },
    { key: '/account', icon: <SettingOutlined />, label: '账号管理' },
  ];

  // 预加载所有路由，提升切换速度
  React.useEffect(() => {
    const prefetch = () => {
      const routes = [
        'Dashboard', 'Classes', 'CourseCategories', 'Teachers', 
        'Students', 'Enrollments', 'Attendance', 'Approvals', 
        'StatsFees', 'StatsTeacherIncome', 'StatsAttendance', 'Account'
      ];
      routes.forEach(page => {
        // 利用动态 import 的特性在后台静默下载静态资源
        import(`../pages/${page}`).catch(() => {});
      });
    };
    // 在主界面渲染完成后，延迟 2 秒开始预加载，避免抢夺初期带宽
    const timer = setTimeout(prefetch, 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider width={200} theme="light">
        <div style={{ padding: '16px', fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
          业训打卡
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <AntLayout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '16px' }}>管理后台</div>
          <div style={{ cursor: 'pointer' }} onClick={handleLogout}>
            <LogoutOutlined /> 退出登录
          </div>
        </Header>
        <Content style={{ margin: '24px', background: '#fff', padding: '24px', minHeight: 280, position: 'relative' }}>
          <ErrorBoundary>
            <Suspense fallback={
              <div style={{ padding: '100px', textAlign: 'center' }}>
                <Spin size="large" tip="页面加载中..." />
              </div>
            }>
              {outlet}
            </Suspense>
          </ErrorBoundary>
        </Content>
      </AntLayout>
    </AntLayout>
  );
}
